import { render, staticRenderFns } from "./QuickMenu.vue?vue&type=template&id=9f7e1848&"
import script from "./QuickMenu.vue?vue&type=script&lang=js&"
export * from "./QuickMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports